module.exports = __webpack_public_path__ + "img/symbol_12.16d6d35b.png";